import { SET_STATIC_CONFIGURATION } from "@/jscommon/src/store/configuration/mutation-types"

export default {
  [SET_STATIC_CONFIGURATION]: function (state, { staticConfiguration }) {
    state.staticConfiguration = staticConfiguration
  },
}
